import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';

export const onboardingGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const currentPath = route.firstChild?.routeConfig?.path || '';
  const queryParams = route.queryParams;
  if (currentPath === 'review' && queryParams['hash']) {
    storage.setSeenOnboarding(true);
    return true;
  }

  if (!storage.hasSeenOnboarding()) {
    router.navigate(['/onboarding']);
    return false;
  }

  return true;
};
